import { render, staticRenderFns } from "./form_anticorruption.vue?vue&type=template&id=449c7b5c&scoped=true&"
import script from "./form_anticorruption.vue?vue&type=script&lang=js&"
export * from "./form_anticorruption.vue?vue&type=script&lang=js&"
import style0 from "./form_anticorruption.vue?vue&type=style&index=0&id=449c7b5c&lang=scss&scoped=true&"
import style1 from "./form_anticorruption.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c7b5c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VForm,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449c7b5c')) {
      api.createRecord('449c7b5c', component.options)
    } else {
      api.reload('449c7b5c', component.options)
    }
    module.hot.accept("./form_anticorruption.vue?vue&type=template&id=449c7b5c&scoped=true&", function () {
      api.rerender('449c7b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_anticorruption.vue"
export default component.exports